import {Box, Divider, MenuItem} from '@mui/material';

import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import Menu from './Menu';
import {LogoutButton} from 'components/login/LogoutButton';
import {useAuthContext} from 'context/AuthContext';
import ChangePasswordDialog from 'components/login/ChangePasswordDialog';
import {useModal} from 'hooks/useModal';

const UserMenu = memo(() => {
   const {t} = useTranslation();
   const {
      authData: {username},
   } = useAuthContext();

   const {open: changeOpened, handleOpen: openChange, handleClose: closeChange} = useModal(false);
   return (
      <>
         <Menu name={username} id="user-menu">
            {/* <MenuLinkOutside
            link="https://www.coviantsoftware.com/support/"
            label={t('Support Center')}
         />
         <MenuLinkOutside
            link="https://www.coviantsoftware.com/report-problems/"
            label={t('Report Problems')}
         /> */}
            {/* <Divider /> */}
            {/* <ThemeSubMenu /> */}
            {/* <Divider /> */}

            <MenuItem onClick={openChange}>{t('Change Password')}</MenuItem>
            <Divider />

            <Box sx={{textAlign: 'center'}}>
               <LogoutButton />
            </Box>
         </Menu>
         {changeOpened && (
            <ChangePasswordDialog onClose={closeChange} data={{username: username}} />
         )}
      </>
   );
});

export default UserMenu;
